<template>
    <div id="alumniMap">
    </div>
</template>

<script>
export default {
  name: "GoogleMaps",
  props: ['continents', 'filter', 'loading'],
  data(){
    return{
      options: {
        gestureHandling: 'cooperative',
        // scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: require('./mapStyles.json'),
        draggable: true,
        backgroundColor: 'none',
        center: {lat: 20, lng: 10},
        zoom: 2,
        maxZoom: 6,
        minZoom: 2
      },
      map: null,
      markersOnMap: [],
    }
  },

  computed: {
    markers() {
      if (this.continents) {
        let markers = []
        Object.entries(this.continents).forEach(([continent, countries]) => {
          Object.values(countries).forEach(country => {
            if(country.tj.length || country.jk.length) {
              markers.push(country)
            } 
          })
        })
        return markers
      }
    }
  },
  methods: {
    clearMarkers() {
      this.markersOnMap.forEach(marker => {
        marker.setMap(null);
      })
    },

    addMarkersToMap() {

      this.markers.forEach(marker => {
        const totalFellows = marker.tj.length + marker.jk.length

        let markerEmoji = ''

        if (marker.emoji) {
          markerEmoji = '<span class="flag-emoji">' + marker.emoji + '</span>'
        } else {
          markerEmoji = ''
        }

        let content = ''
        
        if(marker.jk.length > 0) {
          content = '<h5>'+ markerEmoji + marker.name + ' (' + totalFellows + ')</h5>' +
                    '<label class="font-sans">' + marker.tj.length + '  <span>TJW</span> ' + marker.jk.length + ' <span>JKW</span> </label>'
        } else {
          content = '<h5>'+ markerEmoji + marker.name + ' (' + totalFellows + ')</h5>' +
                    '<label class="font-sans">' + marker.tj.length + '  <span>TJW</span></label>'
        }


        const infowindow = new google.maps.InfoWindow({
          content: content
        });

        const markerOnMap = new google.maps.Marker({
          position: marker.location,
          icon: '/svg/pin-marker.svg?count=' + totalFellows,
          map: this.map
        });

        markerOnMap.addListener('click', ()=> {
          this.$router.push({ path: '/WAT50N/map/list', query: { continent: marker.continent, country: marker.name, markerId: marker.id } })
          // this.openContinent = marker.continent
          // this.openCountry = marker.name
          this.$nextTick(function () {
            this.$scrollTo('#'+marker.id)
          })
        });

        markerOnMap.addListener('mouseover', () => {
            infowindow.open(this.map, markerOnMap);
        });

        markerOnMap.addListener('mouseout', function() {
            infowindow.close();
        });

        this.markersOnMap.push(markerOnMap)
      })
    },
  },
  watch: {
    markers() {
      if(this.markers) {
        this.clearMarkers()
        this.addMarkersToMap()
      }
    }
  },

  mounted() {

    const GoogleMapsLoader = require('google-maps'); 
    GoogleMapsLoader.KEY = 'AIzaSyAW8Z_p6QW0NfGchaL8rJU6nfkXW8f-Lvk';
    GoogleMapsLoader.load((google)=> {
      if(process.browser) {
        const mapEl = document.getElementById('alumniMap')
        this.map = new google.maps.Map(mapEl, this.options);
        if(this.markers) {
          this.addMarkersToMap()
  
        }
      }
    });
  },
}

</script>


// WEBPACK FOOTER //
// scripts/alumni-map.vue